import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import PlayerImageTitleHoriz from "../../image/playerImageTitleHoriz";
import "../../../assets/css/scss/section/player/_profileStatisticsSimilarPlayers.scss";
import "../../../assets/css/scss/section/player/_playerImageSlider.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import fontawesome from '@fortawesome/fontawesome';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronCircleRight,
    faChevronCircleLeft
} from "@fortawesome/fontawesome-free-solid";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { BASEBALL_SIMILAR_PLAYERS } from "../../../constant/match";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../../interfaces/redux";

fontawesome.library.add(faChevronCircleRight, faChevronCircleLeft);
export default function ProfileStatisticsSimilarPlayers(props: any) {
    // eslint-disable-next-line
    const [activeSilderIndex, setactiveSilderIndex] = useState(0)
    const listData = props?.list;
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLang = globalState?.selectedLang || "";
    console.log("slider>", listData)
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <FontAwesomeIcon icon={"chevron-circle-right"} />,
        prevArrow: <FontAwesomeIcon icon={"chevron-circle-left"} />,
        afterChange: (current: number) => setactiveSilderIndex(current),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <section className="similar-player">
            <Container className="theme-light-white">
                <div className="row title">
                    <div className="col-12">
                        <h3 className="bold theme-dark-black mb-0">{BASEBALL_SIMILAR_PLAYERS[selectedLang]['title']}</h3>
                    </div>
                </div>
                <div className="slider-wrapper">
                    {listData && listData.length ?
                        <Slider {...settings}>
                            {
                                listData?.map((data: any) => {
                                    return (
                                        <PlayerImageTitleHoriz {...data} />
                                    )
                                })
                            }
                            {/* <PlayerImageTitleHoriz />
                                <PlayerImageTitleHoriz />
                                <PlayerImageTitleHoriz />
                                <PlayerImageTitleHoriz /> */}
                        </Slider>
                        : null
                    }
                </div>
            </Container>
        </section>
    );
}
